module.exports = __webpack_public_path__ + "img/log-out2.3f4362f0.svg";